export default "__VITE_ASSET__8ec3f742__"